import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import WidgetIcon from 'ContentComponents/cmv2/WidgetIcon';
import DragPreviewIconWrapper from 'layout-dnd-components/DragPreviewIconWrapper';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import EPAddableTile from 'editor-components/sidebar/addableComponents/EPAddableTile';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import EPAddableObject from 'editor-components/sidebar/addableComponents/EPAddableObject';
import { OLAF, EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import { noop } from 'underscore';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import classname from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PATAGONIA_ICON_SIZE = 20;
const PATAGONIA_TILE_SIZE = 80;
const PATAGONIA_TEXT_SIZE = 11;
const PATAGONIA_ADDABLE_OBJECT_MAX_CHARS = 20;
const moduleSource = {
  beginDrag(props) {
    const dragPayload = {
      widgetCid: props.schema.id || props.schema.name,
      type: props.type,
      widgetLabel: props.schema.label,
      widgetPath: props.schema.path,
      isThemeAsset: props.schema.isThemeAsset
    };
    if (props.onDragStart) props.onDragStart(dragPayload);
    return dragPayload;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop() && props.onDragEnd) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    if (props.onDragEnd) props.onDragEnd(dropResult, dragItem);
  }
};
const Draggable = DragSource(DRAG_TYPES.ADD_MODULE, moduleSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}));
const addableObject = type => type === 'allModules' || type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
const addableTile = type => type !== 'allModules' && type !== PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
class DraggableTile extends Component {
  constructor(props) {
    super(props);
    this._icon = null;
    this.toggleWiggleTile = () => {
      this.setState({
        isWiggly: !this.state.isWiggly
      });
    };
    this.state = {
      isWiggly: false
    };
  }
  renderIcon(size) {
    const {
      schema
    } = this.props;
    // TODO switch to using getIconForModule util?
    if (schema.icon || schema.schemaVersion === 2) {
      return /*#__PURE__*/_jsx(WidgetIcon, {
        size: size,
        color: EERIE,
        icon: schema.icon
      });
    }
    return null;
  }
  renderDragPreview() {
    const {
      connectDragPreview,
      schema,
      isDraggable = true
    } = this.props;
    const element = /*#__PURE__*/_jsx("div", {
      className: "hidden-drag-preview",
      children: /*#__PURE__*/_jsx(DragPreviewIconWrapper, {
        isValidDropZone: true,
        children: /*#__PURE__*/_jsx(WidgetIcon, {
          size: "large",
          className: "m-all-auto display-flex",
          color: OLAF,
          ref: icon => {
            this._icon = icon;
          },
          icon: schema.icon
        })
      })
    });
    if (isDraggable && connectDragPreview) {
      return connectDragPreview(element);
    }
    return element;
  }
  renderBaymaxAddableObject() {
    const {
      schema,
      hideTooltips,
      sidebarIframeBody
    } = this.props;
    return /*#__PURE__*/_jsx(EPAddableObject, {
      useOnDark: true,
      _bodyElement: sidebarIframeBody,
      iconNode: this.renderIcon(20),
      text: schema.displayName,
      hideTooltip: hideTooltips,
      maxChars: PATAGONIA_ADDABLE_OBJECT_MAX_CHARS
    });
  }
  renderPatagoniaAddableTile() {
    const {
      sidebarIframeBody,
      schema,
      hideTooltips,
      className,
      isDragging
    } = this.props;
    const {
      isWiggly
    } = this.state;
    const classNames = classname('tile-item', !!className && `${className}`, isWiggly && "wiggly");
    return /*#__PURE__*/_jsx("div", {
      onClick: () => this.toggleWiggleTile(),
      onAnimationEnd: () => this.toggleWiggleTile(),
      children: /*#__PURE__*/_jsx(EPAddableTile, {
        useOnDark: true,
        _bodyElement: sidebarIframeBody,
        iconNode: this.renderIcon(PATAGONIA_ICON_SIZE),
        text: schema.displayName,
        className: classNames,
        hideTooltip: hideTooltips,
        isDragging: isDragging,
        tileSize: PATAGONIA_TILE_SIZE,
        textSize: PATAGONIA_TEXT_SIZE
      })
    });
  }
  render() {
    const {
      connectDragSource,
      schema,
      isVisible,
      isDraggable,
      type,
      style,
      useLockedRibbon,
      useNewRibbon
    } = this.props;
    if (!isVisible) {
      return null;
    }
    let draggableElement = null;
    if (addableObject(type)) {
      draggableElement = this.renderBaymaxAddableObject();
    } else if (addableTile(type)) {
      draggableElement = this.renderPatagoniaAddableTile();
    }
    const liStyle = addableObject(type) ? Object.assign({
      width: '100%'
    }, style) : style;
    const extraRibbonStyles = {};
    let ribbonType;
    if (useLockedRibbon) {
      ribbonType = 'candy-apple';
    } else if (useNewRibbon) {
      ribbonType = 'new';
      extraRibbonStyles.cursor = 'grab';
    }
    const showRibbon = useLockedRibbon || useNewRibbon;
    const liElement = /*#__PURE__*/_jsxs("li", {
      "data-hs-dragdrop": true,
      "data-widget-id": schema.id || schema.name,
      "data-test-widget-name": schema.name && schema.name,
      style: liStyle,
      className: "m-bottom-3",
      onMouseDown: showRibbon ? this.props.onMouseDown : noop,
      children: [showRibbon && /*#__PURE__*/_jsxs(UIRibbon, {
        use: ribbonType,
        style: Object.assign({
          paddingTop: 2,
          boxShadow: 'none'
        }, extraRibbonStyles),
        children: [useLockedRibbon && /*#__PURE__*/_jsx(UIIcon, {
          name: "locked",
          size: 14
        }), !useLockedRibbon && useNewRibbon && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addModule.newBanner"
        })]
      }), draggableElement]
    });
    if (isDraggable && connectDragSource) {
      return connectDragSource(liElement);
    }
    return liElement;
  }
}

// Need a hook into the component without the react-dnd wrapper, in order to deal with
// timing issues when forcing rendering of "fake" components in InpageSidebarPortal (prior
// to copying styled component styles over)
DraggableTile.propTypes = {
  hideTooltips: PropTypes.bool,
  style: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  isDraggable: PropTypes.bool.isRequired,
  // (injected by react-dnd)
  connectDragSource: PropTypes.func.isRequired,
  // @ts-expect-error Deprecated custom proptype validator
  sidebarIframeBody: (props, propName) => {
    if (props.isDraggable === true && typeof props[propName] !== 'object') {
      throw new Error('sidebarIframeBody is required if isDraggable is true');
    } else {
      return null;
    }
  },
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool,
  type: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
  className: PropTypes.string,
  useLockedRibbon: PropTypes.bool,
  useNewRibbon: PropTypes.bool,
  onMouseDown: PropTypes.func
};
DraggableTile.defaultProps = {
  isVisible: true,
  isDraggable: true,
  style: {}
};
export const UnwrappedDraggableTile = DraggableTile;
export default Draggable(DraggableTile);